import { createActionCreator } from '@pressreader/appstore';
import type { BookmarkType, CollectionWithId } from '@pressreader/social-types';

import { MODULE_NAME } from '../../constants';

const pre = MODULE_NAME + '/bookmarks/';

type AddBookmarkPayloadBookmarkData<T extends BookmarkType> = T extends BookmarkType.article
    ? { articleId: string }
    : T extends BookmarkType.pageSet
    ? { pageSetId: string }
    : T extends BookmarkType.pages
    ? { issueKey: string; pages: number[] }
    : never;

interface AddBookmarkPayload<T extends BookmarkType> {
    bookmarkType: T;
    bookmarkData: AddBookmarkPayloadBookmarkData<T>;
    collections?: CollectionWithId[];
}

type AddBookmarkPayloadAny = AddBookmarkPayload<BookmarkType>;

const addBookmarkAction = createActionCreator<AddBookmarkPayloadAny>(`${pre}load_article_collections_action`);
const addBookmarkBegan = createActionCreator<AddBookmarkPayloadAny>(`${pre}load_article_collections_began`);
const addBookmarkDone = createActionCreator<AddBookmarkPayloadAny>(`${pre}load_article_collections_done`);
const addBookmarkFailed = createActionCreator<AddBookmarkPayloadAny>(`${pre}load_article_collections_failed`);

export type { AddBookmarkPayload };
export { addBookmarkAction, addBookmarkBegan, addBookmarkDone, addBookmarkFailed };
